import {SocialLink} from "entities/social-link";

export const headerData = {
    icons: [
        {iconBootstrap: "bi bi-instagram", height: 25, width: 25, to:"https://www.instagram.com/viti_krut/"},
        {iconBootstrap: "bi bi-facebook", height: 25, width: 25,to:"https://www.facebook.com/viti.edu.ua/"},
        {iconBootstrap: "bi bi-youtube", height: 25, width: 25,to:"https://www.youtube.com/@Військовийінституттелекомуніка"},
        {iconBootstrap: "bi bi-tiktok", height: 25, width: 25,to:"https://www.tiktok.com/@viti_krut?_t=8ZUHTA4Hyis"}
    ] as SocialLink[],
}